import React, { useEffect, useState } from 'react';
import uploadFile from '../../services/upload-files.service';
import useFetch from '../../hooks/useFetch';

export default function ImportReport() {
  const [tspUploadData, setTspUploadData] = useState({ seller: '', year: '', templateFile: null });
  const [griUploadData, setGriUploadData] = useState({ seller: '', year: '', templateFile: null });
  const [uploadingTSP, setUploadingTSP] = useState(false);
  const [uploadingGRI, setUploadingGRI] = useState(false);
  const [messageTSP, setMessageTSP] = useState('');
  const [messageGRI, setMessageGRI] = useState('');
  const [errors, setErrors] = useState({}); // To store validation errors
  const { data } = useFetch('suppliers');
  const [selectedSeller, setSelectedSeller] = useState(null);

  useEffect(() => {
  }, [selectedSeller]); // This runs when selectedSeller changes

  const handleFileChange = (event, formType) => {
    const { name, value, files } = event.target;

    if (name === "seller" && !selectedSeller) {

      const seller = data.results?.find((seller) => seller.name === value);

      if (seller) {
        setSelectedSeller(seller);
      }
    }



    if (formType === 'TSP File') {
      setTspUploadData((prevData) => ({
        ...prevData,
        [name]: name === 'templateFile' ? files[0] : value,
        seller_id: selectedSeller?.id || '',
        seller_name: selectedSeller?.name || '',
      }));
    } else if (formType === 'GRI File') {
      setGriUploadData((prevData) => ({
        ...prevData,
        [name]: name === 'templateFile' ? files[0] : value,
        seller_id: selectedSeller?.id || '',
        seller_name: selectedSeller?.name || '',
      }));
    }

    // Clear errors for the field being edited
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`${formType}-${name}`]: '',
    }));

    if (formType === 'TSP File') setMessageTSP('');
    if (formType === 'GRI File') setMessageGRI('');
  };

  const validateFields = (formType) => {
    let formUploadData = formType === 'TSP File' ? tspUploadData : griUploadData;
    let validationErrors = {};

    if (!formUploadData.seller) {
      validationErrors[`${formType}-seller`] = 'Please Select Seller';
    }
    if (!formUploadData.year) {
      validationErrors[`${formType}-year`] = 'Please Enter Year';
    }
    if (!formUploadData.templateFile) {
      validationErrors[`${formType}-templateFile`] = 'Please Select File';
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      ...validationErrors,
    }));

    return Object.keys(validationErrors).length === 0;
  };

  const handleUploadClick = async (formType) => {
    if (!validateFields(formType)) return;

    let formUploadData = formType === 'TSP File' ? tspUploadData : griUploadData;
    let setUploadMessage = formType === 'TSP File' ? setMessageTSP : setMessageGRI;
    let setUploadingState = formType === 'TSP File' ? setUploadingTSP : setUploadingGRI;
     let setUploadData = formType === 'TSP File' ? setTspUploadData : setGriUploadData;
    let inputname = formType === 'TSP File' ? 'read-tsp-excel-file' : 'read-gri-excel-file';

    

    const { seller, year, templateFile } = formUploadData;

    setUploadingState(true);
    try {
      let res = await uploadFile(formUploadData, inputname, formType);
      if (res.status === 200) {
        setUploadMessage('Successfully Uploaded!');
        if (formType === 'TSP File') {
          setTspUploadData({ seller: '', seller_id: '', seller_name: '', year: '', templateFile: null });
        } else if (formType === 'GRI File') {
          setGriUploadData({ seller: '', seller_id: '', seller_name: '', year: '', templateFile: null });
        }
      }
    } catch (error) {
      console.error(error);
    }
    setUploadingState(false);
  };

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">Import Report</h1>
        </div>

        {/* Upload TSP File */}
        <div className="col-md-6">
          <h4 className="mt-3">Upload TSP File</h4>
          <div className="upload-container">
            <div className="border-container">
              <div className="mb-3">
                <label htmlFor="Seller" className="form-label">
                  Seller <span style={{ color: 'red' }}>*</span>
                </label>
                <select
                  className="form-select"
                  name="seller"
                  value={tspUploadData.seller}
                  onChange={(e) => handleFileChange(e, 'TSP File')}
                >
                  <option value="">Select Seller</option>
                  {data.results &&
                    data.results.map((val) => (
                      <option key={val.id} value={val.name}>
                        {val.name}
                      </option>
                    ))}
                </select>
                {errors['TSP File-seller'] && (
                  <div className="error" style={{ color: 'red' }}>{errors['TSP File-seller']}</div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="year" className="form-label">
                  Year <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="year"
                  value={tspUploadData.year}
                  onChange={(e) => handleFileChange(e, 'TSP File')}
                />
                {errors['TSP File-year'] && (
                  <div className="error" style={{ color: 'red' }}>{errors['TSP File-year']}</div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="templateFile" className="form-label">
                  File <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="templateFile"
                  onChange={(e) => handleFileChange(e, 'TSP File')}
                />
                {errors['TSP File-templateFile'] && (
                  <div className="error" style={{ color: 'red' }}>{errors['TSP File-templateFile']}</div>
                )}
              </div>

              <button
                className="btn btn-primary btn-add float-end"
                onClick={() => handleUploadClick('TSP File')}
                disabled={uploadingTSP}
              >
                {uploadingTSP ? 'Uploading...' : 'Upload'}
              </button>
              <p style={{ color: 'green' }}>{messageTSP}</p>
            </div>
          </div>
        </div>

        {/* Upload GRI File */}
        <div className="col-md-6">
          <h4 className="mt-3">Upload GRI File</h4>
          <div className="upload-container">
            <div className="border-container">
              <div className="mb-3">
                <label htmlFor="Seller" className="form-label">
                  Seller <span style={{ color: 'red' }}>*</span>
                </label>
                <select
                  className="form-select"
                  name="seller"
                  value={griUploadData.seller}
                  onChange={(e) => handleFileChange(e, 'GRI File')}
                >
                  <option value="">Select Seller</option>
                  {data.results &&
                    data.results.map((val) => (
                      <option key={val.id} value={val.name}>
                        {val.name}
                      </option>
                    ))}
                </select>
                {errors['GRI File-seller'] && (
                  <div className="error" style={{ color: 'red' }}>{errors['GRI File-seller']}</div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="year" className="form-label">
                  Year <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="year"
                  value={griUploadData.year}
                  onChange={(e) => handleFileChange(e, 'GRI File')}
                />
                {errors['GRI File-year'] && (
                  <div className="error" style={{ color: 'red' }}>{errors['GRI File-year']}</div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="templateFile" className="form-label">
                  File <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="templateFile"
                  onChange={(e) => handleFileChange(e, 'GRI File')}
                />
                {errors['GRI File-templateFile'] && (
                  <div className="error" style={{ color: 'red' }}>{errors['GRI File-templateFile']}</div>
                )}
              </div>

              <button
                className="btn btn-primary btn-add float-end"
                onClick={() => handleUploadClick('GRI File')}
                disabled={uploadingGRI}
              >
                {uploadingGRI ? 'Uploading...' : 'Upload'}
              </button>
              <p style={{ color: 'green' }}>{messageGRI}</p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
